module.exports = "/images/bwburgerizzr.png?ac640d29112a5d504c798555e7a23774";